import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PermanentJobsService } from '../services';
import { factoryJobPostKey } from '../factories/queries';

export const useGenerateJobDescription = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ postingId, officeId }: { postingId: string; officeId?: string }) =>
      PermanentJobsService.generateJobDescription(postingId, officeId),
    onSuccess: (_, { postingId }) => {
      queryClient.invalidateQueries({ queryKey: factoryJobPostKey(postingId) });
    },
  });
};
